var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchantLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 41,
    viewBox: "0 0 111 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00602 17.7478H4.52151C5.63597 17.7478 6.52754 16.862 6.52754 15.7548C6.52754 14.6475 5.63597 13.7617 4.52151 13.7617H2.00602C0.891566 13.7617 0 14.6475 0 15.7548C0 16.862 0.891566 17.7478 2.00602 17.7478Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0322266 1.92978C0.0322266 2.87886 0.700901 3.63812 1.62431 3.82793C1.62431 3.85957 1.71983 3.85957 1.87904 3.8912H6.01846C7.61054 3.8912 9.04341 5.31482 9.74393 6.77006L9.8713 7.02315C10.0942 7.56096 10.3489 8.16204 10.6355 8.82639C10.6355 8.85802 10.6673 8.85802 10.6673 8.88966C11.7181 11.3256 13.3739 11.8002 16.0167 11.8002H20.8248H26.3334L23.0219 4.30247L22.799 3.82793C22.6716 3.54321 22.5124 3.25849 22.3532 3.0054C21.7482 2.08796 20.9522 1.3287 19.9651 0.790895C19.9333 0.790895 19.9014 0.759259 19.9014 0.759259C19.8696 0.759259 19.8377 0.727623 19.8059 0.727623C19.2646 0.442901 18.7551 0.284722 18.3093 0.189815C17.6725 0 17.2267 0 17.2267 0H16.8128H6.27319H1.94273H1.8472C0.828268 0.0632716 0.0322266 0.885802 0.0322266 1.92978Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5031 36.7941C35.5349 36.7625 35.5349 36.7309 35.5667 36.6992C35.9488 36.0349 38.4643 30.0873 38.4643 30.0873C38.4643 30.0873 38.7828 29.2648 38.2733 28.4423C38.0186 27.9994 37.3817 27.4932 36.6175 27.5248H36.4902H19.2638H18.5315H17.4488H17.0986H17.0031C16.8757 27.5248 16.812 27.5565 16.7483 27.5565C15.8568 27.7147 15.1562 28.5056 15.1562 29.4546C15.1562 30.4986 16.016 31.3844 17.0986 31.3844C17.1304 31.3844 17.1623 31.3844 17.1941 31.3844H18.1175C19.6141 31.3844 20.9833 32.8397 21.6201 34.2L22.9256 36.9207C23.9445 39.3566 26.3645 41.065 29.1984 41.065C32.0642 41.0017 34.4841 39.2617 35.5031 36.7941Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1085 1.92978C36.1085 2.21451 36.0449 2.49923 35.9175 2.72068C35.9175 2.75231 35.8857 2.78395 35.8857 2.81559C35.8857 2.84722 35.3443 4.01775 35.3443 4.04938L32.001 11.7685H46.4252C47.9218 8.35185 49.291 5.15664 50.4054 2.59414C50.9468 1.36034 49.9278 0 48.5905 0H41.84H38.1146H34.2299C35.2807 0.0316358 36.1085 0.885802 36.1085 1.92978Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7614 20.7536L16.6848 22.6201C16.7485 22.7467 16.8441 22.9365 16.9396 23.1263C17.0351 23.3161 17.1306 23.5059 17.258 23.6641C17.3217 23.7907 17.4172 23.9172 17.4809 24.0121C18.4361 25.2459 20.1874 25.499 21.8432 25.499H26.5558H40.2158H40.375C41.5532 22.8416 42.8268 19.8678 44.1005 16.9573C44.3234 16.4828 44.4826 16.0715 44.4826 15.7235C44.4508 14.2683 43.2726 13.7621 42.5403 13.7621H42.0308H31.2365C31.1728 13.7621 31.1091 13.7937 31.0773 13.857L29.2941 17.938C29.2305 18.0646 29.0394 18.0646 28.9757 17.938L28.5618 17.2104C28.4981 17.0839 28.4344 16.989 28.3707 16.8624C27.9886 16.2297 27.511 15.6919 26.9697 15.249C25.8871 14.3632 24.5179 13.7937 23.0532 13.7305C22.9577 13.7305 22.894 13.7305 22.7984 13.7305H17.1943H12.8002H10.5076C9.45679 13.7621 8.62891 14.6163 8.62891 15.6603C8.62891 16.6093 9.32942 17.4002 10.221 17.5584C10.2528 17.59 10.3484 17.59 10.5076 17.59H12.3225C13.9146 17.59 14.9654 19.0136 15.6659 20.4373L15.7614 20.7536Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.403 17.5268L96.1297 3.48047H93.6143L101.193 20.0576L99.696 23.2212C99.0273 24.6448 98.4223 25.5939 96.9895 25.5939C96.4482 25.5939 95.9387 25.499 95.5566 25.3092L95.3019 27.1757C95.8432 27.4288 96.6074 27.5553 97.3397 27.5553C99.8552 27.5553 100.906 25.9735 101.957 23.5376L111 3.48047H108.484L102.403 17.5268Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2541 6.86584C80.4322 5.66368 81.8651 4.99932 83.8711 4.99932C86.9598 4.99932 88.9021 6.92911 88.9021 9.96614V11.1367C87.31 10.757 85.5587 10.5672 83.9985 10.5672C79.8591 10.5672 77.0889 12.6236 77.0889 15.6606C77.0889 18.6027 79.3178 20.5325 82.6612 20.5325C85.3359 20.5325 87.724 19.1405 88.934 16.7046L88.9976 20.2161H91.2266V9.68142C91.2266 5.75858 88.5519 3.13281 84.4124 3.13281C81.7059 3.13281 79.7317 3.95534 78.1715 5.44223L79.2541 6.86584ZM83.298 18.8558C80.9417 18.8558 79.5088 17.5904 79.5088 15.629C79.5088 13.6043 81.4193 12.2439 84.2851 12.2439C85.7498 12.2439 87.4056 12.4337 88.9021 12.7817C88.934 16.6729 85.9727 18.8558 83.298 18.8558Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5758 16.6413C60.7221 19.014 62.951 20.5641 66.3262 20.5641C71.0388 20.5641 74.414 17.0842 74.414 11.801C74.414 6.61275 71.0706 3.13281 66.3262 3.13281C62.9829 3.13281 60.7221 4.68297 59.5758 7.05565L59.5121 3.44917H57.2832V27.2077H59.5758V16.6413ZM65.7849 5.12587C69.5104 5.12587 72.0259 7.78328 72.0259 11.8327C72.0259 15.882 69.5422 18.6027 65.7849 18.6027C62.0913 18.6027 59.5758 15.9137 59.5758 11.8643C59.5758 7.81491 62.0595 5.12587 65.7849 5.12587Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 40.705H57.855V37.753H61.14V37.006H57.855V34.747H61.374V34H57V40.705Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.388 40.813C65.765 40.813 66.845 39.76 66.845 38.311C66.845 36.862 65.774 35.827 64.388 35.827C63.002 35.827 61.931 36.862 61.931 38.311C61.931 39.76 63.011 40.813 64.388 40.813ZM64.388 40.066C63.461 40.066 62.75 39.319 62.75 38.32C62.75 37.321 63.461 36.574 64.388 36.574C65.315 36.574 66.026 37.321 66.026 38.32C66.026 39.319 65.315 40.066 64.388 40.066Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7985 35.881C69.2225 35.881 68.7635 36.088 68.5115 36.529V35.935H67.7645V40.705H68.5385V37.861C68.5385 37.069 68.9975 36.619 69.6815 36.619H70.1855V35.881H69.7985Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6663 35.827C77.0003 35.827 76.4423 36.133 76.1363 36.673C75.8483 36.151 75.2993 35.827 74.6423 35.827C74.0753 35.827 73.5893 36.07 73.3193 36.484V35.935H72.5633V40.705H73.3373V37.816C73.3373 37.06 73.7873 36.574 74.4623 36.574C75.1463 36.574 75.5873 37.051 75.5873 37.816V40.705H76.3613V37.816C76.3613 37.06 76.8113 36.574 77.4863 36.574C78.1703 36.574 78.6113 37.051 78.6113 37.816V40.705H79.3853V37.564C79.3853 36.556 78.6563 35.827 77.6663 35.827Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7573 38.113C84.7573 36.898 83.8933 35.827 82.5343 35.827C81.2023 35.827 80.2123 36.871 80.2123 38.311C80.2123 39.751 81.2293 40.813 82.5973 40.813C83.5783 40.813 84.3523 40.282 84.6493 39.625L83.9743 39.265C83.7223 39.751 83.2813 40.111 82.6063 40.111C81.7693 40.111 81.0583 39.499 81.0223 38.554H84.7213C84.7483 38.401 84.7573 38.248 84.7573 38.113ZM81.0403 37.888C81.1483 37.024 81.7873 36.511 82.5343 36.511C83.2363 36.511 83.8933 37.096 83.9023 37.888H81.0403Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6227 35.881C87.0467 35.881 86.5877 36.088 86.3357 36.529V35.935H85.5887V40.705H86.3627V37.861C86.3627 37.069 86.8217 36.619 87.5057 36.619H88.0097V35.881H87.6227Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9557 40.813C91.8827 40.813 92.6837 40.255 92.9807 39.553L92.2877 39.193C92.0537 39.715 91.5767 40.066 90.9557 40.066C90.0557 40.066 89.3897 39.31 89.3897 38.32C89.3897 37.312 90.0557 36.574 90.9557 36.574C91.5767 36.574 92.0537 36.925 92.2877 37.447L92.9807 37.087C92.6837 36.376 91.8917 35.827 90.9557 35.827C89.5877 35.827 88.5707 36.88 88.5707 38.311C88.5707 39.742 89.5877 40.813 90.9557 40.813Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9395 35.827C95.3635 35.827 94.8685 36.061 94.5805 36.457V34H93.8065V40.705H94.5805V37.816C94.5805 37.069 95.0575 36.574 95.7685 36.574C96.4885 36.574 96.9475 37.069 96.9475 37.816V40.705H97.7215V37.573C97.7215 36.565 96.9745 35.827 95.9395 35.827Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.652 35.827C99.7703 35.827 98.9963 36.331 98.7262 36.979L99.4193 37.339C99.6263 36.871 100.076 36.565 100.652 36.565C101.282 36.565 101.732 36.925 101.732 37.474V37.609L100.076 37.978C99.1132 38.194 98.5462 38.68 98.5462 39.382C98.5462 40.219 99.2303 40.813 100.247 40.813C100.859 40.813 101.426 40.516 101.75 40.039V40.705H102.506V37.474C102.506 36.502 101.741 35.827 100.652 35.827ZM100.292 40.12C99.7253 40.12 99.3652 39.832 99.3652 39.382C99.3652 38.995 99.7162 38.698 100.256 38.581L101.732 38.239V38.653C101.732 39.49 101.129 40.12 100.292 40.12Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.651 35.827C105.066 35.827 104.553 36.07 104.274 36.484V35.935H103.518V40.705H104.292V37.816C104.292 37.069 104.769 36.574 105.48 36.574C106.2 36.574 106.659 37.06 106.659 37.816V40.705H107.433V37.564C107.433 36.565 106.686 35.827 105.651 35.827Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.526 40.759C110.661 40.759 110.85 40.75 111.003 40.714V40.084C110.904 40.102 110.769 40.111 110.67 40.111C109.851 40.111 109.797 39.553 109.797 39.247V36.673H110.949V35.935H109.797V34.387H109.023V35.233C109.023 35.656 108.753 35.935 108.339 35.935H108.096V36.673H109.023V39.247C109.023 40.21 109.563 40.759 110.526 40.759Z",
    fill: "#AB3882"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.00177457,
    y1: 15.7528,
    x2: 50.5432,
    y2: 15.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.022376,
    y1: 5.88048,
    x2: 50.5638,
    y2: 5.88048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.00139653,
    y1: 34.2635,
    x2: 50.5428,
    y2: 34.2635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0.00189563,
    y1: 5.88048,
    x2: 50.5433,
    y2: 5.88048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0.00159391,
    y1: 19.6348,
    x2: 50.543,
    y2: 19.6348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 57.2727,
    y1: 15.4974,
    x2: 110.994,
    y2: 15.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 57.2731,
    y1: 11.847,
    x2: 110.994,
    y2: 11.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 57.2729,
    y1: 15.1775,
    x2: 110.994,
    y2: 15.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantLogo);
export default __webpack_public_path__ + "static/media/merchant-logo.c1b78556e0823c92e8e4aebffc116e97.svg";
export { ForwardRef as ReactComponent };